var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "role"
  }, [_c('vue-element-loading', {
    attrs: {
      "active": _vm.isLoading,
      "spinner": "bar-fade-scale",
      "color": "#FF6700"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "animated fadeIn"
  }, [_c('div', {
    staticClass: "col-md-12 mb-2"
  }, [_c('b-card', [_c('div', {
    staticClass: "card-body1"
  }, [_c('form', [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('label', [_vm._v(" AWB Number :")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "red",
      "font-size": "13px"
    }
  }, [_vm._v("\n                  (Note: Use Comma(,) for Multiple AWB Numbers , Maximum 10 AWB numbers allowed.) ")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-book'></i>"
    }
  }, [_c('b-form-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required:true|Max_AWBs'),
      expression: "'required:true|Max_AWBs'"
    }],
    attrs: {
      "id": "AWB",
      "name": "AWB Number",
      "type": "textarea",
      "rows": 3
    },
    model: {
      value: (_vm.awbnumber),
      callback: function($$v) {
        _vm.awbnumber = $$v
      },
      expression: "awbnumber"
    }
  })], 1), _vm._v(" "), _c('span', {
    staticClass: "text-danger",
    attrs: {
      "id": "AWB"
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('AWB Number')),
      expression: "errors.has('AWB Number')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('AWB Number')) + " ")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v("Hub Name :")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa  fa-calendar-o'></i>"
    }
  }, [_c('Multiselect', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required: true}"
    }],
    staticStyle: {
      "border": "1px solid #c2cfd6"
    },
    attrs: {
      "name": "hubname",
      "options": _vm.newhublist,
      "placeholder": "Select Hub Name",
      "label": "label",
      "track-by": "label"
    },
    model: {
      value: (_vm.hubname),
      callback: function($$v) {
        _vm.hubname = $$v
      },
      expression: "hubname"
    }
  })], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('hubname')),
      expression: "errors.has('hubname')"
    }],
    staticClass: "text-danger"
  }, [_vm._v("Hub name is required. ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-"
  }, [_c('div', {
    staticClass: "m-4"
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.Submitfunction
    }
  }, [_vm._v(" Submit ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "reset"
    },
    on: {
      "click": _vm.resetForm
    }
  }, [_vm._v(" Reset ")])])])])]), _vm._v(" "), (_vm.successShipment || _vm.failedShipments.length) ? _c('div', [_c('p', [_vm._v("Success Shipment Count: " + _vm._s(_vm.successShipment))])]) : _vm._e(), _vm._v(" "), (_vm.successShipment || _vm.failedShipments.length) ? _c('div', [_c('p', [_vm._v("Failed Shipments Count: " + _vm._s(_vm.failedShipments.length ? _vm.failedShipments.length : 0))])]) : _vm._e(), _vm._v(" "), (_vm.failedShipments.length) ? _c('div', _vm._l((_vm.failedShipments), function(x) {
    return _c('span', [_vm._v(_vm._s(x) + ", ")])
  })) : _vm._e()])])], 1)])], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-34f91b2a","hasScoped":true}!./src/views/components/StockistShipmentHub/StockistShipmentHub.component.html
// module id = 902
// module chunks = 1